import { includes, last, split } from 'lodash';

import { CLOUDINARY_CONTENTFUL_AUTO_UPLOAD_FOLDER } from 'constants/cloudinary';
import {
  IMAGE_HOST as CONTENTFUL_IMAGE_HOST,
  VIDEO_HOST as CONTENTFUL_VIDEO_HOST,
  BASE_PATH as CONTENTFUL_BASE_PATH,
} from 'constants/contentful';

class RemoteAssetSource {
  static get sources() {
    return {
      contentfulImage: {
        name: 'contentfulImage',
        type: 'image',
        basePath: CONTENTFUL_BASE_PATH,
        cloudinaryAutoUploadFolder: CLOUDINARY_CONTENTFUL_AUTO_UPLOAD_FOLDER,
        requestPathParser(assetSrc) {
          return last(split(assetSrc, `${CONTENTFUL_IMAGE_HOST}/${CONTENTFUL_BASE_PATH}/`));
        },
      },
      contentfulVideo: {
        name: 'contentfulVideo',
        type: 'video',
        basePath: CONTENTFUL_BASE_PATH,
        cloudinaryAutoUploadFolder: CLOUDINARY_CONTENTFUL_AUTO_UPLOAD_FOLDER,
        requestPathParser(assetSrc) {
          return last(split(assetSrc, `${CONTENTFUL_VIDEO_HOST}/${CONTENTFUL_BASE_PATH}/`));
        },
      },
    };
  }

  static getSource(assetSrc) {
    let source;

    if (includes(assetSrc, `${CONTENTFUL_IMAGE_HOST}/${CONTENTFUL_BASE_PATH}/`)) {
      source = RemoteAssetSource.sources.contentfulImage;
    } else if (includes(assetSrc, `${CONTENTFUL_VIDEO_HOST}/${CONTENTFUL_BASE_PATH}/`)) {
      source = RemoteAssetSource.sources.contentfulVideo;
    } else {
      throw new Error(`utils:RemoteAssetSource.getSource - ${assetSrc} is not supported.`);
    }

    return source;
  }

  static parseRequestPath(assetSrc) {
    const { requestPathParser } = RemoteAssetSource.getSource(assetSrc);

    return requestPathParser(assetSrc);
  }

  static parseRequestType(assetSrc) {
    const { type } = RemoteAssetSource.getSource(assetSrc);

    return type;
  }

  static parseBasePath(assetSrc) {
    const { basePath } = RemoteAssetSource.getSource(assetSrc);

    return basePath;
  }

  static parseCloudinaryAutoUploadFolder(assetSrc) {
    const { cloudinaryAutoUploadFolder } = RemoteAssetSource.getSource(assetSrc);

    return cloudinaryAutoUploadFolder;
  }
}

export default RemoteAssetSource;
